export const yesNoOptions = [
	{ label: "Yes", value: "true" },
	{ label: "No", value: "false" },
];
